export const supportedLocales = ["en", "es", "fr", "sw", "tlh", "zh-CN"];
export const localeStorageKey = "autar.locale";
export const localeCookieKey = "autar_locale";

export function resolveLocale(saved, browser, defaultLocale = "en") {
  if (supportedLocales.includes(saved)) return saved;
  const normalizedBrowser = browser?.toLowerCase();
  if (normalizedBrowser?.startsWith("es")) return "es";
  if (normalizedBrowser?.startsWith("fr")) return "fr";
  if (normalizedBrowser?.startsWith("sw")) return "sw";
  if (normalizedBrowser?.startsWith("tlh")) return "tlh";
  if (
    normalizedBrowser === "zh" ||
    normalizedBrowser?.startsWith("zh-cn") ||
    normalizedBrowser?.startsWith("zh-hans")
  )
    return "zh-CN";
  return supportedLocales.includes(defaultLocale) ? defaultLocale : "en";
}

export function createLocaleCookie(locale) {
  return `${localeCookieKey}=${locale}; Path=/; Max-Age=31536000; SameSite=Lax`;
}

export function interpolate(message, parameters) {
  if (!parameters) return message;
  return message.replace(/{{([a-zA-Z0-9_]+)}}/g, (token, name) =>
    Object.prototype.hasOwnProperty.call(parameters, name)
      ? String(parameters[name])
      : token,
  );
}
